export function decorator(Klass) {
    var instantiated = Klass.__instantiated = {};
    Klass.getInstance = function (config) {
        if (!config)
            return null;
        var guid = config._guid;
        if (!instantiated[guid]) {
            instantiated[guid] = new Klass(config);
        }
        return instantiated[guid];
    };
    return Klass;
}
